import React from "react";
import useWindowDimensions from "../../../../../../../../components/get-diemensions/UseWindowDiemensions";
import { PromotionCard } from "./components";

const PromotionsTable = ({ setSelectedPromo, data, search }) => {
  const { width, height } = useWindowDimensions();
  const date = new Date();
  return (
    <div
      style={{
        width: "100%",
        height: height,
        // borderStyle: "solid",
        display: "flex",
        justifyContent: "flex-start",
        flexDirection: "column",
        alignItems: "center",
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: "100%",

          justifyContent: "center",
        }}
      >
        {data
          ? data.length >= 1
            ? data.map((item, index) => {
                return search === "" ? (
                  <div key={index}>
                    <PromotionCard
                      date={new Date(item.createdOn).toLocaleString()}
                      name={item.promotionName}
                      onClick={() => setSelectedPromo(item)}
                      status={item.status}
                      description={item.description}
                      category={item.category}
                      discountAmount={item.discountAmount}
                      createdBy={item.createdBy}
                    />
                  </div>
                ) : item.promotionName
                    .toLowerCase()
                    .match(search.toLowerCase()) ? (
                  <div key={index}>
                    <PromotionCard
                      date={new Date(item.createdOn).toLocaleString()}
                      name={item.promotionName}
                      onClick={() => setSelectedPromo(item)}
                      status={item.status}
                      description={item.description}
                      category={item.category}
                      discountAmount={item.discountAmount}
                      createdBy={item.createdBy}
                    />
                  </div>
                ) : null;
              })
            : "no promotion avalible"
          : null}
      </div>
    </div>
  );
};

export default PromotionsTable;
